export default {
    'delete': "Delete",
    'cancel': "Cancel",
    'yes': "Yes",
    'no': "No",
    'pdf': "PDF",
    'order': "Order",
    'my-orders': "My Orders",
    'print-labels': "print labels",
    'delete-labels': "delete labels",
    'mail-labels': "mail labels",
    'customer-name': "Customer name",
    'details': "Details",
    'customer-email': "Customer email",
    'customer-phone': "Customer phone",
    'delivery-time': "Delivery time",
    'delivery-date': "Delivery date",
    'close': "Close",
    'search': "Search",
    'select-shipping': "Select shipping date and time",
    'submit': "Submit",
    'shopping-cart': "Shopping Cart",
    'total': "Total",
    'submit-order': "Submit order",
    'day': "Day",
    'evening': "Evening",
    'no-hours-available': "No hours available, please choose another day.",
    'the-date-has-not': "The date has not yet been selected.",
    'order-not-placed': "Order not placed, error!",
    'error-heading-generic': "Something went wrong",
    'order-successfully-created': "Order successfully created",
    'payment-status': "Payment status",
    'card-holder-name': "Card Holder Name",
    'login': "Login",
    'login-with-google': "Login With Google",
    'login-with-github': "Login With Github",
    'dashboard': "Dashboard",
    'profile': "Profile",
    'logout': "Logout",
    'clear': "Clear",
    'add-to-cart': "Add to cart",
    'there-are-no-products': "There are no products in the catalog.",
    'return': "Return",
    'update': "Update",
    'create': "Create",
    'save': "Save",
    'back': "Back",
    'save-changes': "Save Changes",
    'reset-password': "Reset password",
    'created': "Created",
    'in-processing': "In processing",
    'completed': "Completed",
    'last-10-orders': "Last 10 orders",
    'number-of-orders': "Number of orders",
    'payment': "Payment",
    'my-category': "My Category",
    'new-item': "New Item",
    'sort': "Sorting Mode",
    'are-you-sure-you-want': "Are you sure you want to delete this item?",
    'are-you-sure-you-want-items': "Are you sure you want to delete this items?",
    'ok': "OK",
    'select': "Select",
    'your-plan-is': "Your Plan is",
    'select-plan': "Select Plan",
    'no-payment-method': "No payment method found, please add a payment method.",
    'ending-in': "Ending In",
    'exp': "Exp",
    'remove': "Remove",
    'you-subscribing-to': "You're subscribing to",
    'edit-order': "Edit order",
    'order-id': "Order id",
    'created-order': "Created order",
    'add-variation': "Add variation",
    'add-variation-item': "Add variation item",
    'delete-variation': "Delete variation",
    'variation': "variation",
    'price-change': "Price change {productName}",
    'reorder-price-change': "Price change {productName}",
    'reorder-missing': "1 product is no longer available and was not added | {count} products are no longer available and were not added",
    'reorder': "Order again",
    'reorder-replace': "Replace",
    'reorder-add': "Add",
    'reorder-cart-not-empty': "Your cart is not empty. Replace it with this order or add to it?",
    'reorder-failed': "This order cannot be reordered right now",
    'no-orders-yet': "You have not placed any orders yet",
    'order-note': "Note",
    'ordered-on': "ordered on {date} at {time}",
    'order-pickup': "Pick up",
    'order-vending': "Vending machine",
    'variations': "Variations",
    'variation-name': "Variation name",
    'variation-value': "Variation value",
    'image': "Image",
    'categories': "Categories",
    'price': "Price",
    'type-here-description': "Type here description text...",
    'description': "Description",
    'product-name': "Product name",
    'my-product': "My Product",
    'this-is-old-page': "This is Old page, please use other Settings page",
    'fields': "Fields",
    'color-theme': "Color Theme",
    'code': "Code",
    'copy': "Copy",
    'sign-up': "Sign Up",
    'home': "Home",
    'password-reset': "Password Reset",
    'password': "Password",
    'reset': "Reset",
    'about': "About",
    'forgot-password': "Forgot Password",
    'privacy-policy': "Privacy policy",
    'faq': "FAQ",
    'streamlined-integration': "Added in one line",
    'your-hassle-free': "From order to collection, in one place",
    'enabled': "Enabled",
    'enter-subject': "Enter subject",
    'email-subject': "Email subject",
    'template-for': "Template for",
    'preview': "Preview",
    'template-context-info': 'If you surround any listed variable name with curly braces, the variable will be injected into the template sent to the customer.',
    'variable': "Variable",
    'step-1': "Step 1",
    'let-our-experts': "We look at how you work and what you need.",
    'step-2': "Step 2",
    'smooth-onboarding': "We set up your account and get you going.",
    'step-3': "Step 3",
    'experience-personalized': "Something not working the way you want? We adjust it.",
    'step-4': "Step 4",
    'dive-into-comprehensive': "We show you how to manage products, hours and orders.",
    'step-5': "Step 5",
    'congratulations-you-are-all': "Done. Your first order can come in.",
    'get-started-for-free': "Get started for free",
    'optimize-delivery-logistics': "Decide yourself when you take orders",
    'streamline-your-delivery': "Set your opening hours, collection times and holidays. Around the festive season you can simply cap the number of orders per hour, so it stays manageable behind the counter.",
    'organize-your-logistics': "Plan your collection times",
    'improve-efficienty': "Fewer mistakes, less wasted time",
    'attract-more-customers': "Customers who keep coming back",
    'online-booking-software': "Online booking software and all-in-one automation platform",
    'besteller-powerful-and-simple': "Besteller - Powerful and Simple Ecommerce Solution!",
    'for-scheduling': "for scheduling",
    'about-us': "About us",
    'clients': "Clients",
    'free-trial': "Free trial",
    'blog': "Blog",
    'contacts': "Contacts",
    'contact-us': "Contact us",
    'register': "Register",
    'sign-in': "Sign in",
    'effortsless-order': "Manage orders and products, with your own collection times",
    'discover-seamless-control': "You see at a glance what has been ordered, for which day and for which customer. You manage products, prices and collection times yourself. No technical knowledge needed and no expensive link to your till.",
    'easy-to-use': "Simple product management",
    'no-need-to-pay': "Print your order lists and labels, even on the busiest days",
    'many-useful-actions': "Ready for the busy days",
    'online-orders-acceptance': "Take orders without the phone",
    'get-more-orders-online': "Put the order form on your own website and take orders outside opening hours",
    'online-support': "Support in Dutch",
    'you-are-not-alone': "You are not on your own. If you have a question, you get an answer from someone who knows the platform.",
    'client-database': "Client database",
    'keep-track-of-all-clients': "Keep track of all clients' data like appointment history, no shows and membership status with simple-to-use CRM software.",
    'powerful-management-tools': "Everything in one place",
    'overview-and-manage': "View and manage your orders, products, collection times and opening hours in one place",
    'seamless-integration': "Fits on your own website",
    'its-very-easy': "You do not need to be a programmer. You get one line of code to paste into your website and the order form is there. If that does not work out, we do it for you.",
    'inventory-and-accounting': "Inventory and accounting",
    'monitor-consumables-and-items': "Monitor consumables and items in stock with inventory tool as part of our ERP system. Get procurement, staff salaries and other expense reports.",
    'revenue-increase': "orders handled since 2023",
    'orders-this-year': "orders in 2026",
    'more-monthly-orders': "customers who order again",
    'easy-to-use-solution': "line of code on your own website",
    '10-million': "10 million",
    'appointments-booked-per-month': "appointments booked per month",
    'professionals-available': "professionals available for online booking",
    'boost-orders-and-revenue': "Fewer phone calls during the rush, more time in the shop",
    'revolutionize-your-sales': "Many customers would rather not call during the lunchtime rush. With an order form on your own site they place their order when it suits them, and you prepare it calmly.",
    'all-in-one': "One form: order, collection time and payment",
    'easy-integration': "Works on the website you already have",
    'user-friendly-interface': "Easy to use",
    'allergenen': "Allergens",
    'ingredients': "Ingredients",
    'position-must-be-positive': "Position must be >= 0",
    'position': "Position",
    'catalog': "Catalog",
    'name': "Name",
    'phone': "Phone number",
    'email': "E-mail",
    'log-in': "Log in",
    'order-details': "Order details",
    'additional-bread': "Bread",
    'additional-vegetables': "Vegetables",
    'additional-meat': "Meat",
    'customer_number': 'customer number',
    'additional-customer-number': "Customer number",
    'additional-voucher-short': "Voucher",
    'additional-voucher': "{value} EUR voucher: I have a {value} EUR voucher and I will take it with me when I pick up my order.",
    'users': "Users",
    'schedule': "Schedule",
    'price-plans': "Price Plans",
    'orders': "Orders",
    'widget-settings': "Widget Settings",
    'shop-settings': "Shop Settings",
    'products': "Products",
    'are-you-sure': "Are you sure?",
    'title': "Title",
    'qty': "Qty",
    'monthly-price': "Monthly Price",
    'active': "Active",
    'activated': 'Yes',
    'not_activated': 'No',
    'loading-please-wait': "Loading... Please wait",
    'billing': "Billing",
    'billing-checkout': "Billing checkout",
    'choose-working-hours': "Choose working hours",
    'build-a-widget': "Build a widget",
    'energize-your-business': "An ordering system built for a shop, not for a webshop",
    'automate-your-shop': "Set your products, opening hours, holidays and collection times. The form takes them into account automatically, so nobody can order for a day you are closed.",
    'password-reset-confirmed': "Password Reset Confirmed",
    'password-confirmation': "Password Confirmation",
    'error-login': "Invalid credentials",
    'status': "Status",
    'id': "id",
    'client-id': "Client id",
    'category-name': "Category name",
    'select-a-localization': "Select a localization",
    'notifications': "Notifications",
    'mollie-key': "Mollie key",
    'mollie-disabled': "The Mollie integration is temporarily disabled. Please contact support@matica.be.",
    'processing-time-in-hours': "Processing time in hours",
    'number-of-orders-per-hour': "Number of orders per hour",
    'time-zone': "Time zone",
    'text-color': "Text color",
    'image-url': "Image url",
    'type-here-ingredients': "Type here ingredients...",
    'type-here-allergenen': "Type here information about \"allergenen\"...",
    'select-a-shop-mode': "Select a Shop mode",
    'open': "Open",
    'paid': "Paid",
    'canceled': "Canceled",
    'expired': "Expired",
    'failed': "Failed",
    'new': "New",
    'mon': "Mon",
    'tue': "Tue",
    'wed': "Wed",
    'thu': "Thu",
    'fri': "Fri",
    'sat': "Sat",
    'sun': "Sun",
    'font': "Font",
    'time': "Time",
    'actions': "Actions",
    'date': "Date",
    'agreement': "Agreement",
    'pickup-at': "Pickup at",
    'amount': "Amount",
    'we-deliver-orders': "We deliver orders",
    'delivery-price': "Delivery price",
    'delivery-desc': "Delivery description",
    'zipcode': "Zipcode",
    'min-order-cost': "Min order cost",
    'cost': "Cost",
    'deliver-to-other-zipcodes': "Deliver to other zipcodes",
    'add-zipcodes': "Add zipcodes",
    'pick-up': "Pick up",
    'delivery': "Delivery",
    'address': "Address",
    'info': "Info",
    'number-of-add-items-per-hour': "Number of add items per hour",
    'sorry-we-dont-delivery': "Sorry we don't delivery to this address yet",
    'the-time-of-delivery-depends': "The time of delivery depends on the traffic and the most logical route. We take your desired delivery time into account as well as possible. All lunches are delivered between 11h and 12h30, the Friday afternoon delivery you can expect between 15h and 18h.",
    'all': "All",
    'extra_processing_time': "Extra processing time",
    'payment_method': "Payment method",
    'payment_methods': "Payment methods",
    'payment_method_cash': "Cash",
    'payment_method_card': "Credit card",
    'required-fields': "Required fields",
    'required-end-date': "Required start date and end date",
    'required-end-time': "Required start time and end time",
    'times': "Times",
    'dates': "Dates",
    'go-to-checkout': "Go to checkout",
    'vat-number': "VAT number",
    'today': "Today",
    'yesterday': "Yesterday",
    'weekly': "Weekly",
    'templates': "Templates",
    'subject': 'Subject',
    'type': 'Type',
    'body': "Body",
    'email_subject': "Subject",
    'email_text': "Text",
    'excel-export': "Excel export",
    'holiday': "Holiday",
    'vat-not-found': "This VAT number was not found",
    'notify_about_promotions': "Notify about promotions",
    'save-an-account': "Save an account",
    'account': "Account",
    'only-pickup': "Only pickup",
    'notify_order_created': 'A new order has just been created',
    'msg-orders-per-hour-is-exceeded': 'Error message when the number of orders per hour is exceeded',
    'add-new': "Add new",
    'template-select-placeholder': 'Template for',
    'send-email': 'Send email',
    'ready-to-go': "Ready to start?",
    'lets-start': 'Let\'s start',
    'dialog-email-send-title': 'Email Templates',
    'repeat-last-order': 'Repeat last order',
    'unavailable-items-from-last-order': 'Some items from your previous order are unavailable',
    'add-item-to-cart': 'Add item to the cart',
    'send-message': 'Send message',
    'message': 'Message',
    'what-types-of-business': 'What types of businesses can benefit from your services?',
    'our-services-are-designed': 'Our services are designed to cater to a wide range of businesses, including retail stores, service-based businesses, e-commerce websites, and more. Whether you\'re a small startup or an established enterprise, our solutions can be tailored to meet your specific needs',
    'how-do-i-get': 'How do I get started with your services?',
    'getting-started-is-easy': 'Getting started is easy! Simply sign up or click the “Get started for free” button, and one of our experts will reach out to discuss your requirements and determine the best solution for your business.',
    'what-sets-your-company': 'What sets your company apart from competitors?',
    'we-pride-ourselves': 'We pride ourselves on our personalized approach and dedication to customer satisfaction. Our supervised setup process, ongoing support, and commitment to continuous improvement ensure that you get the most out of our services. Additionally, our expertise in ecommerce sets us apart in delivering tailored solutions for your business.',
    'is-your-software': 'Is your software compatible with existing systems or platforms?',
    'yes-our-software': 'Yes, our software is designed to integrate seamlessly with a variety of existing systems and platforms. Whether you\'re using WordPress, Shopify, or other third-party applications, we can customize our solutions to work harmoniously with your current setup.',
    'how-can-i-get': 'How can I get in touch with your support team if I have questions or need assistance?',
    'were-here-to-help': 'We\'re here to help! You can reach our support team via the contact page or our social media channels. Our knowledgeable representatives are available to assist you with any inquiries or issues you may encounter, ensuring a smooth experience with our services.',
    'seamless-storefront-solution': "Online ordering for butchers, bakers and delis",
    'your-hassle-free-integrate': "Your customers order ahead through your own website and pick their own collection time. You get a clear list every day. No webshop, no hassle.",
    'we-re-here-to-help': "We are happy to help",
    'our-team-will-answer': "We answer your message within one working day",
    'nomadic-soft-stands': "Besteller.io is owned by Matica. We build and maintain websites and web applications for entrepreneurs, and keep this platform running: secure, up to date and supported in Dutch.",
    'for-besteller': "Besteller.io is built for food artisans: butchers, bakers and delis who want their customers to order ahead without setting up a full webshop. No stock management, no shipping costs, no complicated settings. Just an order form that matches how a shop actually works.",
    'demo': 'Demo',
    'convert-visits-into-sales': "Orders arrive while you work",
    'implements-the-shopping-cart-widget': "Your customers order whenever it suits them, including evenings and weekends. They choose their own collection time and pay in advance or on pickup. You no longer have to answer the phone with a queue at the counter.",
    'machine': 'Vending machine',
    'store': 'Pick up',
    'reset-machine': 'Cancel machine',
    'vending': 'Vending',
    'machine-order': 'Machine Order',
    'archive': 'All Order',
    'archive-text': 'Show orders that are both printed and emailed.',
    'success-send-to-vending': 'Success send to vending',
    'uncorrect-response-vending': 'Uncorrect response while sending to vending',
    'failed-send-vending': 'Failed to send to vending',
    'required_price_field': 'Price required',
    'invalid_price_number': 'Price must be high than 0',
    'invalid_code_length': 'Code must have exactly 5 symbols',
    'dialog_vending_title': 'Fill your price and code',
    '*price': '*Price',
    'printed': 'Printed',
    'mailed': 'Mailed',
    'schedule-vending-caption': 'Vending working hours',
    'from': 'From',
    'to': 'To',
    'available': 'Available',
    'point': 'Point',
    'range': 'Range',
    'mailer-settings': 'Mailer Settings',
    'transport': 'Transport',
    'host': 'Host',
    'port': 'Port',
    'username': 'username',
    'encryption': 'Encryption',
    'domain': 'Domain',
    'secret': 'Secret',
    'endpoint': 'Endpoint',
    'select-a-show-mode': 'Select a show mode products',
    'end-at-available': 'Available until',
    'indicator-order': 'Indicator',
    'additional_fields': 'Additional fields',
    'show_details_column': 'Show details column',
    'cart_variation_editable': 'Customer can change the variation (e.g. weight) in the cart',
    'orders_list_settings': 'Order list',
    'orders_table_v2': 'Use the new order list (test version)',
    'printing_show_ordered_at': "Show 'Ordered on' on the label",
    'choose-new-password': "Choose a new password",
    'new-password': "New password",
    'repeat-password': "Repeat password",
    'save-new-password': "Save",
    'password-changed-logged-in': "Your password has been changed. You are now logged in.",
    'reset-link-expired': "This link has expired or is invalid. Request a new one via 'Forgot password'.",
    'customer-linked': "Your email address was already known. Your account now also works at this shop; log in with your existing password.",
    'is_printed': "Printed",
    'notified_at': "Mailed",
    'is_viewed': "Viewed",
    'select-label': "Select:",
    'select-all': "All",
    'select-new': "New",
    'select-count': "{count} selected",
    'select-heading': "Select",
    'print-labels-v2': "Print labels",
    'excel-short': "Excel",
    'more': "More",
    'mail-action': "Mail",
    'delete-action': "Delete…",
    'search-by-name': "Search by name",
    'select-not-printed': "Not printed",
    'select-not-mailed': "Not mailed",
    'pickup_time': "Pickup time",
    'show_more': "show more",
    'show_less': "show less",
    'tt_select_page': "Select all orders on this page",
    'tt_id': "Order number. Click to sort",
    'tt_indicator': "Extras in this order: bread, vegetables or meat",
    'tt_bread': "This order contains bread",
    'tt_vegetables': "This order contains vegetables",
    'tt_meat': "This order contains meat",
    'tt_name': "Customer: name, e-mail and phone",
    'tt_details': "What the customer ordered",
    'tt_show_more': "Show the full order list",
    'tt_show_less': "Show only the first 4 lines",
    'tt_pickup_time': "Day and time slot the customer chose for pickup or delivery. Click to sort",
    'tt_delivery': "This order is delivered, not picked up",
    'tt_status': "Payment and processing status",
    'tt_open': "Not paid online yet (payment at pickup or still in progress)",
    'tt_paid': "Paid online",
    'tt_canceled': "The online payment was canceled",
    'tt_expired': "The online payment has expired",
    'tt_failed': "The online payment failed",
    'tt_new': "Not printed yet or not mailed yet",
    'tt_printed_yes': "Label has been printed",
    'tt_printed_no': "Label has not been printed yet",
    'tt_mailed_yes': "Customer mailed on {date}",
    'tt_mailed_no': "Customer has not been mailed yet",
    'tt_total': "Total amount of the order",
    'tt_show': "View order",
    'tt_vending': "Create the vending machine pickup code and send it",
    'tt_pdf': "Open the PDF of this order",
    'tt_edit': "Edit order",
    'tt_email': "Send an email to the customer (choose a template)",
    'tt_delete': "Delete order",
    'tt_machine': "Vending machine order (M). Click to sort",
    'tt_machine_cell': "Vending machine order",
    'tt_printed': "Has the label of this order been printed?",
    'tt_mailed': "Has the customer been e-mailed about this order?",
    'tt_actions': "Actions for this order",
    'tt_filter_all': "Select all orders in the list",
    'tt_filter_new': "Select the orders that have not been printed or not been e-mailed yet",
    'tt_filter_not_printed': "Select the orders whose label has not been printed yet",
    'tt_filter_not_mailed': "Select the orders for which the customer has not been e-mailed yet",
    'tt_select_count': "Number of ticked orders. Print labels, Excel and More work on this selection",
    'tt_filter_today': "Show the orders that are picked up or delivered today (without \"All Order\": only those not yet completed)",
    'tt_filter_yesterday': "Show the orders that were picked up or delivered yesterday (without \"All Order\": only those not yet completed)",
    'tt_filter_weekly': "Show the orders with a pick-up day this week, Monday to Sunday (without \"All Order\": only those not yet completed)",
    'tt_filter_excel': "Download the selected orders as an Excel file",
    'tt_filter_labels_print': "Print the labels of the selected orders",
    'tt_filter_labels_delete': "Delete the selected orders",
    'tt_filter_labels_mail': "E-mail the selected customers",
    'tt_filter_more': "More actions for the selected orders: mail or delete",
    'tt_filter_date': "Filter by pick-up day (from – to), within the orders shown",
    'tt_filter_time': "Filter by time slot (from – to); works together with a chosen date",
    'tt_filter_clear': "Clear the date and time filter",
    'tt_filter_archive': "Also show orders that have already been printed and e-mailed",
    'tt_filter_search': "Search by customer name",
    'period-label': "Period",
    'show-label': "Show",
    'this-week': "This week",
    'machine-only': "Machine orders only",
    'clear-all-filters': "Clear all filters",
    'tt_filter_machine_only': "Show only machine orders",
    'tt_filter_clear_all': "Resets period, date, time, All orders and Machine orders only. The search stays.",
    'tt_nav_toggle': "Collapse or expand the navigation",
    'order-email-locked': "Change via My details",
    'my-details': "My details",
    'profile-save': "Save",
    'profile-saved': "Your details have been saved",
    'profile-email-pending': "We sent a confirmation link to {newEmail}. Until you click it, {email} stays your address.",
    'profile-email-resend': "Send again",
    'profile-email-resent': "We sent a new confirmation link to {newEmail}",
    'profile-email-taken': "This email address is already in use",
    'profile-too-many': "Too many attempts. Please try again later.",
    'profile-save-failed': "Your details could not be saved",
    'profile-error-name': "Please enter your name",
    'profile-error-phone': "Please enter your phone number",
    'profile-error-email': "Please enter a valid e-mail address",
    'profile-error-password': "Enter the same new password twice",
    'email-change-done': "Your email address has been changed to {email}",
    'email-change-invalid': "This link is no longer valid. Request a new one via My details.",
    'email-change-taken': "This email address is now in use by another account. Nothing was changed.",
    'password-change': "Change password",
    'password-current': "Current password",
    'password-repeat': "Repeat new password",
    'password-changed': "Your password has been changed",
    'password-current-wrong': "Your current password is incorrect",
    'password-mismatch': "The passwords do not match",
    'password-change-failed': "Your password could not be changed",
}
